import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { TkValidator } from 'src/app/validator/tk.validator';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss'],
})
export class ProfileViewComponent implements OnInit {
  userForm: UntypedFormGroup;
  user: any;
  isProfileComplete = true;

  constructor(
    private loginSignupService: LoginSignupService,
    private userService: UserService,
    private toastService: ToastService,
    private router: Router,
    private localStorage: LocalStorageService,
  ) {
    this.isProfileComplete = this.localStorage.getItem("completeProfile") === "true";
    this.initializeForm();
  }

  ngOnInit(): void {
    this.getUserData();
  }

  initializeForm() {
    const formControls = {
      firstName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      lastName: new UntypedFormControl('', [
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      email: new UntypedFormControl({ value: '', disabled: this.isProfileComplete }),
      company: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
      mobile: new UntypedFormControl('', [
        Validators.minLength(10),
        Validators.maxLength(10),
        TkValidator.numberOnly,
        TkValidator.noWhiteSpace,
      ]),
      gstin: new UntypedFormControl('', [
        Validators.minLength(15),
        Validators.maxLength(15),
        TkValidator.noWhiteSpace,
      ]),
    };

    this.userForm = new UntypedFormGroup(formControls);
  }

  changePassword() {
    this.router.navigateByUrl('account/profile/change-password');
  }

  getUserData() {
    const currentOption = {
      email: this.loginSignupService.getUserSession().user.email,
    };
    this.userService.userData(currentOption).then(
      (data: any) => {
        this.user = data;
        this.userForm.patchValue({
          firstName: this.user?.name.split(" ")[0],
          lastName: this.user?.name.split(" ")[1],
          email: this.user?.email,
          company: this.user?.company,
          country: this.user?.country,
          mobile: this.user?.mobile,
          gstin: this.user?.gstin,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  updateUser() {
    const currentOption = {
      email: this.userForm.getRawValue().email,
      name: this.userForm.getRawValue().firstName + " " + this.userForm.getRawValue().lastName,
      country: this.userForm.getRawValue().country,
      mobile: this.userForm.getRawValue().mobile,
      company: this.userForm.getRawValue().company,
      gstin: this.userForm.getRawValue().gstin,
      id: this.user?._id,
      completeProfile: this.userForm.getRawValue().email ? true : false,
    };

    this.userService.updateUserProfile(currentOption).then(
      (data: any) => {
        this.user = data;
        this.userForm.patchValue({
          firstName: this.user?.name.split(" ")[0],
          lastName: this.user?.name.split(" ")[1],
          email: this.user?.email,
          company: this.user?.company,
          country: this.user?.country,
          mobile: this.user?.mobile,
          gstin: this.user?.gstin,
        });
        this.loginSignupService.setUserData(data);
        this.getUserData();
        this.toastService.addSingle(
          'success',
          'Successfully Updated',
          'You have successfully saved.'
        );
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }
}
